import _ from 'underscore';
import { isBlank } from '../helpers/common';

import Base, { baseInit } from './base';
import { File } from './file';

export class Note extends Base {
  id = null; // Integer
  value = null; // String
  _uuid = null; // String - internal field used for referencing Note
  files = null; // [ File{} ]

  constructor(data) {
    super(data);
    baseInit(this, data, true);
    if (this.files === null) {
      this.files = [];
    } else {
      this.files = this.files.map((f) => new File(f));
    }
  }

  newUUID(resetIDs) {
    super.newUUID(resetIDs);
    if (resetIDs) {
      // recurse to nested objects
      if (!isBlank(this.files)) {
        this.files.forEach((file) => {
          file.newUUID(resetIDs);
        });
      }
    }
  }

  isEmpty() {
    return _.isEmpty(this.value) && (this.files !== null ? this.files.length === 0 : true);
  }
}
